import getEnvironment from './get.environment';
import { version } from '../../../package.json';

export default function consoleLogVersion() {
    if (getEnvironment() === 'production')
        return;
    console.log('version', version);
}